/**
 * Point position indicator
 * - used in Charleroi
 * - showing state of PME - should correspond with it
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

import Konva from 'konva'

export default class ChaPpi extends Element {
  setDefaultShapes () {
    this.shapes.push(
      // basic shape three rooms
      new Ren.Rect({
        name: 'ppi',
        x: 0,
        y: 0,
        width: 60,
        height: 30,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      // signalling foor
      new Ren.Line({
        points: [30, 30, 30, 50],
        strokeWidth: 2,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [5, 50, 55, 50],
        strokeWidth: 2,
        opacity: 0.8
      }),

      new Konva.Text({
        name: 'ppiText',
        x: 5,
        y: 10,
        text: '',
        fontSize: 14,
        fill: 'black'
      })
    )
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(newVariables)

    // TODO this has to be redone in proper way (probably using some kind of general device NOT PPI)
    // used for TID1.1
    // reading status.position
    // 0 - JNCT
    // 1 - DEPT
    // 2 - REBR
    // 5 - means no bit set

    const statusText = {
      straight: 'DEPT',
      left: 'JNCT',
      right: 'REBR',
      off: ''
    }

    if (status) {
      for (const [signalName, value] of Object.entries(status)) {
        if (value === 1) {
          this.modifyShape('ppiText', 'text', statusText[signalName])
        }
      }
    }
  }
}
